import React, { Component } from "react";
import { Fade } from "react-awesome-reveal";

export default class Champion extends Component {
  render() {
    const {
      year,
      years,
      image,
      champion,
      placements,
      team,
      ...props
    } = this.props;

    const ids = Object.keys(placements || {});
    const evens = ids.flatMap((id) => {
      return id % 2 === 0 ? placements[id] : [];
    });
    const odds = ids.flatMap((id) => {
      return id % 2 === 1 ? placements[id] : [];
    });

    return (
      <section className="champion-section pt-24 md:pt-40 lg:pt-64" {...props}>
        <div className="container">
          <section className="hero">
            <ChampionSection
              year={year}
              years={years}
              image={image}
              champion={champion}
            />
          </section>
          <section className="flex lg:w-10/12 ml-auto mr-auto mt-20 lg:mb-8">
            <div className="w-1/2">
              <PlacementsSection year={year} placements={evens} />
            </div>
            <div className="w-1/12"></div>
            <div className="w-1/2 pt-20 md:pt-40 lg:pt-64">
              <PlacementsSection year={year} placements={odds} />
            </div>
          </section>
        </div>
        {team && (
          <div className="team-container">
            <div className="container">
              <section className="team lg:w-11/12 ml-auto">
                <img src={team} alt="Team" className="z-40 relative"/>
              </section>
            </div>
          </div>
        )}
      </section>
    );
  }
}

function ChampionSection({ year, years, image, champion }) {
  return (
    <section id={year} className="mb-8">
      <div className="flex flex-no-wrap">
        <div className="lg:w-11/12">
          <div className="block">
            <img
              src={image}
              alt={year}
              className="year-overlay mt-4 md:ml-auto mr-auto w-10/12 lg:w-9/12"
            />
          </div>
          <div
            className="hero-bg hero-offset"
            style={{ backgroundImage: "url(" + champion.image + ")" }}
          />
        </div>
      </div>
      <Fade triggerOnce>
        <div className="lg:w-11/12 mr-auto">
          <div className="pt-4 pl-6 w-1/2 lg:w-1/4 ml-auto">
            <h6 className="h6 text-hugeorange">{year} Champion</h6>
            <p className="h5 mb-1">{champion.name}</p>
            <p>{champion.costume}</p>
          </div>
        </div>
      </Fade>
    </section>
  );
}

function PlacementsSection({ year, placements }) {
  const ids = Object.keys(placements || {});

  return ids.map((id) => {
    const { place, name, costume, image } = placements[id];
    return (
      <section key={`${year}-${place}`}>
        <Fade triggerOnce>
          <div className="placement mb-20 md:mb-32 md:text-left">
            <img src={image} alt={name} className="md:ml-auto" />
            <div className="lg:w-7/12 ml-auto my-8">
              <h6 className="h6 text-hugeorange">
                {year} {place} Place
              </h6>
              <p className="h5 mb-1 leading-4">{name}</p>
              <p>{costume}</p>
            </div>
          </div>
        </Fade>
      </section>
    );
  });
}
